import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import DioceseSegmentAddChild from "./DioceseSegmentAddChild";

const DioceseSegmentAdd = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <DioceseSegmentAddChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default DioceseSegmentAdd;
